import React from 'react';
import { Routes, Route } from 'react-router-dom';
import HomePage from './views/HomePage/HomePage';
import { DatasetList, DatasetView } from './views/Datasets';
import {
    EnvironmentList,
    EnvironmentForm,
    EnvironmentView,
} from './views/Environments';
import { OrganizationList, OrganizationView } from './views/Organizations';
import { PipelineList, PipelineView } from './views/Pipelines';
import * as Notifications from './views/Notifications/';
import { ShareView } from './views/Shares';
import { TableView } from './views/Table';
import {
    WarehouseForm,
    WarehouseList,
    WarehouseView,
} from './views/Warehouses';
// import * as Worksheets from './views/Worksheet'

const Router = () => {
    return (
        <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/discover" element={<HomePage />} />
            <Route
                path="/notifications"
                element={<Notifications.Notifications />}
            />
            <Route path="/organizations" element={<OrganizationList />} />
            <Route path="/organization/:uri" element={<OrganizationView />} />
            <Route path="/environments" element={<EnvironmentList />} />
            <Route
                path="/new-environment/:uri?"
                element={<EnvironmentForm />}
            />
            <Route path="/environment/:uri" element={<EnvironmentView />} />
            <Route path="/datasets" element={<DatasetList />} />
            <Route path="/dataset/:uri" element={<DatasetView />} />
            <Route path="/share/:uri" element={<ShareView />} />
            <Route path="/pipelines" element={<PipelineList />} />
            <Route path="/pipeline/:uri" element={<PipelineView />} />
            <Route path="/table/:uri" element={<TableView />} />
            <Route path="/warehouses" element={<WarehouseList />} />
            <Route path="/new-warehouse" element={<WarehouseForm />} />
            <Route path="/warehouse/:uri" element={<WarehouseView />} />
        </Routes>
    );
};

export default Router;
